import React, { Component } from 'react'
import logo from "../../assets/logo_espol_interno.svg";
import equis from "../../assets/eliminar.svg"
import check from "../../assets/check.svg";
import info from "../../assets/Info.png"
import "../../css/FormRegistro.css";
import axios from 'axios';
import FormRegistroContrasenia from './FormRegistroContrasenia';
import Modal from './Modal';
import Header from '../components/Header.js';
import CenteredWrapper from '../components/CenteredWrapper.js'
import Footer from '../components/Footer.js';
import anuncio from "../../assets/Anuncio.svg";
import anuncioico from "../../assets/AnuncioICO.svg";
import Acuerdo from './Acuerdo.js';
import BotonExpandible from "../components/BotonExpandible";
import RadioSwitch from "../components/RadioSwitch";
import jwt from 'jwt-decode'
import { useNavigate, Navigate } from "react-router-dom";
import LivenessModal from './LivenessModal.js';
import checkGreen from "../../assets/check.png";
import cedimg from "../../assets/FotoCEDULA.svg"
import cedimg_noveri from "../../assets/error-de-validacion.svg"
import cedimg_veri from "../../assets/validacion-exitosa.svg"

import NotificacionTip from "./NotificacionTip";
import Camara from "./Camara.js"
import Visualizarpdf from "../components/Visualizarpdf";
import ModalXL from './ModalXL';
import { isMobile } from 'react-device-detect';
import alarma from "../../assets/alarma.svg";
import { base64ToPdfFile, base64ToFile } from "../../utils/funciones";
import focoanimado from "../../assets/focoanimado.gif";
import error from "../../assets/error.svg";
import alerta from "../../assets/alertacc.svg";
import checkcc from "../../assets/checkcc.svg";

export class FormUpdateSolicitud extends Component {

    constructor(props) {
        super(props);

        this.state = {
            datosUsuario: {
                token: "",
                id: "",
                identificacion: "0",
                alias_sugerido: "",
                telefono: "",
                unidad: "",
                rol: "",
                correoAlterno: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
                usuarioEscogido: "",
                fechaNacimiento: ""
            },
            solicitud: {
                idSolicitud: "",
                motivoSolicitud: "",
                estadoSolicitud: "",
                infosolicitud: "",
                isvalidimgpersona: "",
                isvalidimgtarjeta: "",
                svalidcontrato: "",
            },
            acuerdoFirmado:false,
            redirectInicio: false,
            tokendecodestate: "",
            IsDataCorrect: false,
            modalModocedula: false,
            spinnerUploadCamara: true,
            modalCamaracedula: false,
            modalarchivocedula: false,
            iconGuardCedulaExito: false,
            cedula_base64: "",
            activebutton: true,
            personaviva: false,
            rostro_base64: "",
            isCedulaEqualRostro: false,
            isNumCedulaEqualBase: false,
            activebutton: true,
            modalActualizaciónDocsExitosa: false,
            verFoco: false,
            numerointento: 0,
            tipoCargaDocumentoIdentidad: "",
            vermodalresultvalidacionident: false,
            verAcuerdo: false
        };
    }

    abrirvermodalresultvalidacionident = () => {
        this.setState({
            vermodalresultvalidacionident: true
        });
    }
    cerrarvermodalresultvalidacionident = () => {
        this.setState({
            vermodalresultvalidacionident: false
        });
    }

    changeSpinnerUploadCamara = (valor) => {
        this.setState({
            spinnerUploadCamara: valor
        })
    }

    activebuttonf = () => {
        this.setState({ activebutton: true });
    }

    disabledbuttonf = () => {
        this.setState({ activebutton: false });
    }

    abrirModalActualizaciónDocsExitosa = () => {
        this.setState({
            modalActualizaciónDocsExitosa: true,
        })
    }

    cerrarModalActualizaciónDocsExitosa = () => {
        this.setState({
            modalActualizaciónDocsExitosa: false,
        }, () => {
            if (this.state.isCedulaEqualRostro && !this.state.acuerdoFirmado) {
                this.abrirAcuerdo();
            } else {
                window.location.href = "/Inicio";
            }
        })
    }


    abrirAcuerdo = () => {
        this.setState({ verAcuerdo: true });
    }

    cerrarAcuerdo = () => {
        this.setState({ verAcuerdo: false });
    }

    cerrarModalInfoAcuerdo = () => {
        this.setState({
            modalActualizaciónDocsExitosa: false,
        }, () => {
            this.abrirAcuerdo();
        });
    }


    componentWillMount = () => {
        this.mostrarFoco();
        var ruta = window.location.href;
        var token_temp = ruta.split("token=")[1];
        var tokendecode = jwt(token_temp);
        this.setState({
            tokendecodestate: tokendecode,
        }, () => {
            sessionStorage.setItem("token_nueva_cuenta", token_temp);
            this.validarFirmaAcuerdo();
            var user_temp = this.state.tokendecodestate["User"];
            axios.get(`${process.env.REACT_APP_API}api/Persona/getCedulaByUsername/${user_temp}`)
                .then(r => {
                    if (r.status == 200) {
                        this.setState({
                            datosUsuario: {
                                ...this.state.datosUsuario,
                                identificacion: r.data.identificacion,
                            },
                            IsDataCorrect: true
                        }, () => {
                            axios.get(`${process.env.REACT_APP_API}api/Solicitud/getsolicitudRechazada/${this.state.datosUsuario.identificacion}`)
                                .then(r => {
                                    this.ocultarFoco();
                                    if (r.status == 200) {
                                        this.setState({
                                            solicitud: {
                                                idSolicitud: r.data.idsccesolicitud,
                                                motivoSolicitud: r.data.motivo,
                                                estadoSolicitud: r.data.estado,
                                                infosolicitud: r.data.infosolicitud,
                                                isvalidimgpersona: r.data.isvalidimgpersona,
                                                isvalidimgtarjeta: r.data.isvalidimgtarjeta,
                                                isvalidcontrato: r.data.isvalidcontrato
                                            },
                                            IsDataCorrect: true,
                                        }, () => {
                                          
                                            var infoSolicitudTemp = JSON.parse(this.state.solicitud.infosolicitud);
                                            this.setState({
                                                datosUsuario: {
                                                    ...this.state.datosUsuario,
                                                    alias_sugerido: infoSolicitudTemp.alias_sugerido,
                                                    unidad: infoSolicitudTemp.unidad,
                                                    rol: infoSolicitudTemp.actividad,
                                                    correoAlterno: infoSolicitudTemp.correo,
                                                    nombres: infoSolicitudTemp.nombres,
                                                    apellidos: infoSolicitudTemp.apellidos,
                                                    correo: infoSolicitudTemp.correo,
                                                    usuarioEscogido: infoSolicitudTemp.usuario_sugerido,
                                                },
                                            })
                                        })
                                    }
                                })
                                .catch(error => {
                                    this.ocultarFoco();
                                    this.setState({
                                        IsDataCorrect: false,
                                    })
                                })
                        })
                    }
                })
                .catch(error => {
                    this.setState({
                        IsDataCorrect: false,
                    }, () => {
                        this.ocultarFoco();
                    })
                });
        })
    }

    mostrarFoco = () => {
        this.setState({
            verFoco: true
        })
    }
    ocultarFoco = () => {
        this.setState({
            verFoco: false
        })
    }


    /*abrirModalModocedula = () => {
        this.setState({ modalModocedula: true })
    }*/
    abrirModalModocedula = () => {
        if (this.state.tipoCargaDocumentoIdentidad == "image") {
            this.abrirModalCamaracedula();
        } else if (this.state.tipoCargaDocumentoIdentidad == "document") {
            this.abrirmodalarchivocedula();
        } else {
            this.setState({ modalModocedula: true });
        }
    }

    cerrarModalModocedula = () => {
        this.setState({ modalModocedula: false })
    }

    abrirModalCamaracedula = () => {
        this.setState({ modalCamaracedula: true });
        this.cerrarModalModocedula();
    }

    cerrarModalCamaracedula = () => {
        this.setState({ modalCamaracedula: false })
    }

    abrirmodalarchivocedula = () => {
        this.setState({ modalarchivocedula: true });
        this.cerrarModalModocedula();
    }

    cerrarmodalarchivocedula = () => {
        this.setState({ modalarchivocedula: false })
    }

    Dataimgcedula = dataimgced => {
        if (dataimgced != null) {
            this.setState({
                cedula_base64: dataimgced,
                actCedula: true
            }, () => {
                this.changetipoCargaDocumentoIdentidad("image");
                this.cerrarModalCamaracedula();
                this.changeisCedulaAnalizada(false);

                this.ValidacionDatosCedulaConBase("image");
                this.showiconGuardCedulaExito();
                this.abrirvermodalresultvalidacionident();
            });
        }
    }

    changeNumeroIntento = (valor) => {
        this.setState({
            numerointento: valor + 1
        })
    }

    changetipoCargaDocumentoIdentidad = (valor) => {
        this.setState({
            tipoCargaDocumentoIdentidad: valor
        })
    }

    showiconGuardCedulaExito = () => {
        this.setState({
            iconGuardCedulaExito: true,
            actFirmaElec: true
        });
    }

    ReconocimientoFacialCedula = async () => {
        try {
            const rostro = await base64ToFile(
                this.state.rostro_base64,
                "rostro.jpg"
            );
            const cedula = await base64ToFile(
                this.state.cedula_base64,
                "cedula.jpg"
            );
            const formData = new FormData();
            formData.append("image_one", rostro);
            formData.append("image_two", cedula);

            const r = await axios.post(
                `${process.env.REACT_APP_API_LIVENESS}/analysis/face-recognition/?metric=cosine&model=Facenet&threshold=0.1`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            if (r.data.analysis_result.mismo_individuo) {
                this.changeIsCedulaEqualRostro(true);
                this.changeNumeroIntento(2);
            } else {
                this.changeIsCedulaEqualRostro(false);
                this.changeNumeroIntento(this.state.numerointento);
            }
            this.changeSpinnerUploadCamara(true);
            this.changeisCedulaAnalizada(true);
            this.changenecesitaRevision(false);
            this.changeIsNumCedulaEqualBase(true);
        } catch (error) {
            this.changeisCedulaAnalizada(true);
            this.changeSpinnerUploadCamara(true);
            this.changeIsCedulaEqualRostro(false);
            this.changenecesitaRevision(true);
            //this.changeIsNumCedulaEqualBase(false);
        }
    }

    ValidacionDatosCedulaConBase = async (tipo) => {
        try {
            this.changeSpinnerUploadCamara(false);
            const cedulaPdf = base64ToPdfFile(
                this.state.cedula_base64,
                "cedula.pdf"
            );

            const formData = new FormData();
            formData.append("file", cedulaPdf);
            formData.append("type_document", "cedula");

            const r = await axios.post(
                `${process.env.REACT_APP_API_LIVENESS}/analysis/ci-pv/extraccion`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }
            );
            if (r.data.human_revision) {
                this.changenecesitaRevision(true);
                this.changeIsNumCedulaEqualBase(false);
                this.changeIsCedulaEqualRostro(false);
                this.changeSpinnerUploadCamara(true);
                this.changeisCedulaAnalizada(true);
                this.changeNumeroIntento(this.state.numerointento);
            } else {
                     /*DEBUG*/
                //if (r.data.extracted_data.numero_cedula == "0951500693") {
                
                // Producción 
                if (r.data.extracted_data.numero_cedula == this.state.datosUsuario.identificacion) {
                    this.ReconocimientoFacialCedula();
                    this.changeIsNumCedulaEqualBase(true);
                    /*this.changenecesitaRevision(false);
                    ;
                    this.changeSpinnerUploadCamara(true);
                    this.changeNumeroIntento(2) ;               */
                } else {
                    this.changenecesitaRevision(true);
                    this.changeIsNumCedulaEqualBase(false);
                    this.changeIsCedulaEqualRostro(false);
                    this.changeSpinnerUploadCamara(true);
                    this.changeisCedulaAnalizada(true);
                    this.changeNumeroIntento(this.state.numerointento);
                }
            }
        } catch (error) {
            this.changeSpinnerUploadCamara(true);
            this.changenecesitaRevision(true);
            this.changeIsCedulaValidada(true);
            this.changeIsNumCedulaEqualBase(false);
            this.changeIsCedulaEqualRostro(false);
            this.changeNumeroIntento(this.state.numerointento);
        }
    }

    filechooseCedula = chosefile => {
        if (chosefile != null) {
            this.setState({
                //fotoCedula: chosefile,
                cedula_base64: chosefile,
                actDocPdf: true
            }, () => {
                this.changetipoCargaDocumentoIdentidad("document");
                this.cerrarmodalarchivocedula();
                this.changeisCedulaAnalizada(false);

                this.ValidacionDatosCedulaConBase("pdf");

                this.showiconGuardCedulaExito();
                this.abrirvermodalresultvalidacionident();
            })
        }
    }

    changeisCedulaAnalizada = (valor) => {
        this.setState({
            isCedulaAnalizada: valor
        })
    }

    changeIsCedulaEqualRostro = (valor) => {
        this.setState({
            isCedulaEqualRostro: valor
        })
    }

    changeIsCedulaValidada = (valor) => {
        this.setState({
            isCedulaValidada: valor
        })
    }

    changeIsNumCedulaEqualBase = (valor) => {
        this.setState({
            isNumCedulaEqualBase: valor
        })
    }

    activePersonaViva = () => {
        this.setState({ personaviva: true });
    }

    changeRostroBase64 = (variable) => {
        this.setState({ rostro_base64: variable });
    }

    change_cedula_base64 = (valor) => {
        this.setState({
            cedula_base64: valor
        })
    }

    changenecesitaRevision = (valor) => {
        this.setState({
            necesitaRevision: valor
        })
    }

    seguirPostRectificarDocs = () => {
        this.setState({
            vermodalresultvalidacionident: false
        });
        if (this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA)) {
            //this.postVerificarAlias();
            this.postRectificarDocs();
        }
        else {
            if (this.state.tipoCargaDocumentoIdentidad == "image") {
                this.abrirModalCamaracedula();
            } else if (this.state.tipoCargaDocumentoIdentidad == "document") {
                this.abrirmodalarchivocedula();
            }
        }
    }

    validarFirmaAcuerdo = async () => {
         axios.get(`${process.env.REACT_APP_API}api/Persona/isfirmaacgencUs/${this.state.tokendecodestate["User"]}`)
            .then(r => {
                if (r.status == 200) {
                    var firmo_temp = "";
                    if(r.data.Aceptodatospers == "si"){
                        firmo_temp=true;
                    }else{
                        firmo_temp=false;
                    }
                    this.setState({
                        acuerdoFirmado:firmo_temp
                    })
                }
            })
            .catch(error => {
                this.setState({
                        acuerdoFirmado:false
                    })
            })
    }

    postRectificarDocs = async () => {
        this.disabledbuttonf();
        var solicitud = {
            estado: "Rechazado cc",
            Motivo: "Rechazado cc",
            Identificacion: this.state.datosUsuario.identificacion,
            isvalidimgpersona: this.state.solicitud.isvalidimgpersona,
            isvalidimgtarjeta: this.state.solicitud.isvalidimgtarjeta,
            isvalidcontrato: this.state.solicitud.isvalidcontrato,
            fotoimgCedula: this.state.cedula_base64,
            fotoimgRostro: this.state.rostro_base64,
            filePdf: this.state.pdfData,
            isCedulaEqualRostro: this.state.isCedulaEqualRostro,
            InfoSolicitud: this.state.solicitud.infosolicitud
        }
        axios.put(`${process.env.REACT_APP_API}api/Solicitud/repalaceDocs/${this.state.solicitud.idSolicitud}`, solicitud, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
            }
        })
            .then(resp => {
                this.activebuttonf();
                this.abrirModalActualizaciónDocsExitosa(true);
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error con validación del token",
                            mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                            imagen: equis,
                        }
                    });
                } else {
                    this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error en la solicitud de actualización de documentos de la firma del acuerdo manual",
                            mensaje: error.response.data.errorMessage,
                            imagen: equis,
                        }
                    });;
                }
                this.activebuttonf();
            });
    }



    render() {
        const fechaLimite = (() => {
            const fecha = new Date();
            fecha.setDate(fecha.getMonth() + 1);
            const dia = String(fecha.getDate()).padStart(2, '0');
            const mes = String(fecha.getMonth() + 1).padStart(2, '0');
            const anio = fecha.getFullYear();
            return `${dia}/${mes}/${anio}`;
        })();
        if (this.state.verFoco) {
            return (
                <Modal isOpen={this.state.verFoco} cerrarModal={this.ocultarFoco} verBoton={false} >
                    <h4 className='text-center'><strong>Consultando solicitudes</strong></h4>
                    <img className="acuerdo-modal-logo" src={focoanimado} alt="Cargando..." style={{ objectFit: "contain", height: "100px", width: "100%" }}></img>
                </Modal>
            )
        }
        else {
            if (!this.state.personaviva && this.state.IsDataCorrect) {
                return (
                    <LivenessModal
                        activePersonaViva={this.activePersonaViva}
                        changeRostroBase64={this.changeRostroBase64}
                    />
                )
            } else {
                return (
                    this.state.IsDataCorrect ?
                        (
                            this.state.verAcuerdo ?
                                <Acuerdo
                                    identificacion={this.state.datosUsuario.identificacion}
                                    nombres={this.state.datosUsuario.nombres}
                                    apellidos={this.state.datosUsuario.apellidos}
                                    alias_sugerido={this.state.datosUsuario.alias_sugerido}
                                    usuario_sugerido={this.state.datosUsuario.usuarioEscogido}
                                    correoAlterno={this.state.datosUsuario.correoAlterno}
                                    rol={this.state.datosUsuario.rol}
                                    telefono={this.state.datosUsuario.telefono}
                                    unidad={this.state.datosUsuario.unidad}
                                    tipoForm={"CC"}
                                    mensaje_titulo="CREAR CUENTA"
                                    verbtngeneral={false}
                                    verbtngeneralElectronica={true}
                                    callTagManager={this.props.callTagManager}
                                    /* useEffect={this.props.useEffect}*/
                                    showHeader={false}
                                    tipo_token={"propio"}
                                />
                                :
                                <div >
                                    <Header />
                                    <CenteredWrapper>
                                        <div className="registro-container">
                                            <div className="container">
                                                <div className="row">
                                                    <BotonExpandible
                                                        mensaje={
                                                            <div style={{ textAlign: "left" }}>
                                                                <strong>
                                                                    Si la información presentada no es correcta por favor contactarse con{" "}
                                                                    <a href="mailto:gerenciatecnologia@espol.edu.ec">
                                                                        gerenciatecnologia@espol.edu.ec
                                                                    </a>
                                                                </strong>
                                                                <br /><br />
                                                                <span style={{ fontWeight: 200 }}>
                                                                    El motivo del rechazo de su solicitud y del bloqueo de su cuenta electrónica es el siguiente:<em> {this.state.solicitud.motivoSolicitud}</em>
                                                                </span>
                                                            </div>

                                                        }
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div className="col-12 ">
                                                        <p className="registro-title">Rectificación de documentación para <br /> creación de cuenta electrónica</p>
                                                    </div>
                                                </div>

                                                <div className='row-form-e'>
                                                    <div className="row-form-datos-e col-10">
                                                        <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                            <label htmlFor="identificacion" id="registro-textoLabel">IDENTIFICACIÓN </label>
                                                            <input className="form-control" type="text" name="identificacion" defaultValue={this.state.datosUsuario.identificacion} disabled></input>
                                                        </div>

                                                        <div className="col-12 col-md-12 col-xl-11  mt-2"  >
                                                            <label id="registro-textoLabel" htmlFor="nombres">NOMBRE(S) </label>
                                                            <input className="form-control" type="text" name="nombres" defaultValue={this.state.datosUsuario.nombres.toUpperCase()} disabled></input>
                                                        </div>

                                                        <div className="col-12 col-md-12 col-xl-11 mt-2" >
                                                            <label id="registro-textoLabel" htmlFor="apellidos">APELLIDO(S) </label>
                                                            <input className="form-control" type="text" name="apellidos" defaultValue={this.state.datosUsuario.apellidos.toUpperCase()} disabled></input>
                                                        </div>

                                                        <div className="col-12 col-md-12 col-xl-11 mt-2">

                                                            <label id="registro-textoLabel" htmlFor="alias_sugeridoalias_sugerido">ALIAS: </label>

                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="alias"
                                                                    placeholder="nombre.apellido"
                                                                    name="alias_sugerido"
                                                                    value={this.state.datosUsuario.alias_sugerido}
                                                                    disabled
                                                                />
                                                                <div id="registro-textoLabel" className="input-group-text" style={{ backgroundColor: "#E9ECEF" }}>@espol.edu.ec</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div className="row-seleccion-usuario">
                                                        <div className="row-seleccion-usuario-texto mt-4">
                                                            <label id="registro-textoLabel" >USUARIO: </label>
                                                        </div>

                                                        <div className="row-seleccion-usuario-opciones">
                                                            <div className="col-xl-12 mt-3 usuarios">
                                                                <div className="form-check" key={this.state.datosUsuario.usuarioEscogido}>
                                                                    <input className="form-check-input"
                                                                        type="radio"
                                                                        name="usuarioEscogido"
                                                                        id="usuarioEscogido"
                                                                        value={this.state.datosUsuario.usuarioEscogido}
                                                                        defaultChecked={true}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="usuarioEscogido">{this.state.datosUsuario.usuarioEscogido}</label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <br />

                                                <div className="registro-container-botonGuardar">
                                                    <button
                                                        disabled={
                                                            this.state.activebutton &&
                                                                this.state.personaviva &&
                                                                this.state.spinnerUploadCamara
                                                                ? false : true}
                                                        type="submit"
                                                        className={

                                                            this.state.activebutton &&
                                                                this.state.personaviva &&
                                                                this.state.spinnerUploadCamara
                                                                ?
                                                                "registro-btn-submit" : "registro-btn-submit-disabled"}
                                                        onClick={this.abrirModalModocedula}>Seguir
                                                    </button>

                                                    {!this.state.activebutton ?
                                                        <span className="registroContra-fr-top spinner-border text-primary ms-2" role="status" aria-hidden="true"></span>
                                                        : null}

                                                </div>
                                            </div>
                                        </div>
                                    </CenteredWrapper>
                                    <Footer />

                                    {
                                        this.state.modalModocedula &&
                                        <Modal isOpen={this.state.modalModocedula} cerrarModal={this.cerrarModalModocedula} verBoton={false} >
                                            <div className='documento-identidad'>
                                                <p className='text-center acuerdo-modalFME-titulo'><strong>Subir documento de identidad</strong></p>
                                                <br />
                                                <div className="col-10">
                                                    <NotificacionTip mensaje="Seleccione el método para subir el documento de identidad" />
                                                </div>
                                                <br />
                                                <div className="row-opciones-documento" >
                                                    <div className="col-10">
                                                        <button onClick={this.abrirModalCamaracedula} className="identidad-camara-button">
                                                            <div className="row" style={{ justifyContent: 'center' }} >
                                                                <div className=" col-10 col-md-10 col-xl-10">
                                                                    <p className="acuerdo-recuadro-texto-button">Cámara</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                    <div className="col-10">
                                                        <button onClick={this.abrirmodalarchivocedula} className="identidad-documento-button">
                                                            <div className="row" style={{ justifyContent: 'center' }} >
                                                                <div className=" col-10 col-md-10 col-xl-10">
                                                                    <p className="acuerdo-recuadro-texto-button">Subir PDF</p>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </Modal>
                                    }
                                    {
                                        this.state.modalCamaracedula &&
                                        <Modal isOpen={this.state.modalCamaracedula} cerrarModal={this.cerrarModalCamaracedula} verBoton={false} >
                                            <Camara imgRostro={this.Dataimgcedula} rostro={false} identificacion={this.state.datosUsuario.identificacion} />
                                        </Modal>
                                    }
                                    {
                                        this.state.modalarchivocedula &&
                                        <ModalXL modalXXL={true} isOpen={this.state.modalSubirPdf} cerrarModal={this.cerrarModalSubirPdf} verBoton={false} >
                                            <Visualizarpdf choosepdf={this.filechooseCedula} />
                                        </ModalXL>
                                    }

                                    {
                                        this.state.vermodalresultvalidacionident &&
                                        <Modal
                                            isOpen={this.state.vermodalresultvalidacionident}
                                            cerrarModal={this.cerrarvermodalresultvalidacionident}
                                            verBoton={false}
                                            textoBoton="Validar identificación"
                                            srcImagen={
                                                this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada &&
                                                (
                                                    this.state.isCedulaEqualRostro
                                                        ? cedimg_veri
                                                        : cedimg_noveri
                                                )
                                            }
                                            claseHeader={
                                                this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada &&
                                                (
                                                    this.state.isCedulaEqualRostro
                                                        ? "identificador_exito"
                                                        : "identificador_error"
                                                )

                                            }
                                        >
                                            <div className="row modal_nuevo">
                                                {!this.state.spinnerUploadCamara ?
                                                    <h4 className='text-center'><strong>Validando documento...</strong></h4>
                                                    :
                                                    null
                                                }
                                                <div className="paso-icono">
                                                    {!this.state.spinnerUploadCamara ?
                                                        <img className="acuerdo-modal-logo" src={focoanimado} alt="Cargando..." style={{ objectFit: "contain", height: "100px", width: "100%" }}></img>
                                                        :
                                                        <>
                                                            {/*this.state.iconGuardCedulaExito && this.state.isCedulaAnalizada ?
                                                                    <>
                                                                        {this.state.isCedulaEqualRostro ?                
                                                                            <img className="acuerdo-modal-logo" src={cedimg_veri} alt="Exitoso"></img>
                                                                            :    
                                                                            <img className="acuerdo-modal-logo" src={cedimg_noveri} alt="Exitoso"></img>                                                            
                                                                        }
                                                                    </>
                                                                :
                                                                    <img className="acuerdo-modal-logo" src={cedimg} alt="Subir imagen"></img>
                                                                */}
                                                            <div className="contenedor-mensaje-modal">
                                                                {this.state.isCedulaAnalizada && (
                                                                    <>
                                                                        {this.state.isNumCedulaEqualBase ?
                                                                            (
                                                                                <div className="contenedor-interno-mensaje-modal">
                                                                                    <img className="icon-text" src={checkcc} alt="Exito"></img>
                                                                                    <div className="mensaje-modal">
                                                                                        <p className='mensaje-informativo'>Se validó con éxito el número de identificación</p>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                            :
                                                                            (
                                                                                <div className="contenedor-interno-mensaje-modal">
                                                                                    <img className="icon-text" src={error} alt="Subir imagen"></img>
                                                                                    <div className="mensaje-modal">
                                                                                        <p className='mensaje-error'>Documento de identidad no admitido</p>
                                                                                        <p>Asegurese de que:</p>
                                                                                        <ol>
                                                                                            <li>Identidad <span>(los datos pertenezcan al titular solicitante)</span></li>
                                                                                            <li>Calidad de imagen <span>(fotografía nítida, enfocada y sin reflejos que obstruya la legibilidad)</span></li>
                                                                                            <li>Documento íntegro <span>(sin daños ni enmendaduras)</span></li>
                                                                                        </ol>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {this.state.isCedulaEqualRostro ?
                                                                            (
                                                                                <div className="contenedor-interno-mensaje-modal">
                                                                                    <img className="icon-text" src={checkcc} alt="Exito"></img>
                                                                                    <div className="mensaje-modal">
                                                                                        <p className='mensaje-informativo'>Se valido el rostro de la persona.</p>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                            :
                                                                            (
                                                                                <div className="contenedor-interno-mensaje-modal">
                                                                                    <img className="icon-text" src={error} alt="Subir imagen"></img>
                                                                                    <div className="mensaje-modal">
                                                                                        <p className='mensaje-error'>Error de validación de rostro de la persona</p>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </>
                                                                )}
                                                                {this.state.necesitaRevision && this.state.isCedulaAnalizada && this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA) &&
                                                                    <div className="contenedor-interno-mensaje-modal">
                                                                        <img className="icon-text" src={alerta} alt="alerta"></img>
                                                                        <div className="mensaje-modal">
                                                                            <p className='mensaje-informativo'>No se pudo validar correctamente. Se actualizará su solicitud para que un asesor verifique la información</p>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </>
                                                    }
                                                </div>

                                                {!this.state.spinnerUploadCamara ?
                                                    null
                                                    :
                                                    <button onClick={this.seguirPostRectificarDocs} className="modal-btn-submit">
                                                        {this.state.numerointento >= Number(process.env.REACT_APP_NUMERO_INTENTO_EXTRACCION_CEDULA) ?
                                                            <p className="n">Actualizar solicitud</p>
                                                            :
                                                            <p className="">Volver a validar</p>
                                                        }
                                                    </button>
                                                }
                                            </div>
                                        </Modal>
                                    }
                                    {
                                        this.state.modalActualizaciónDocsExitosa &&
                                            (this.state.isCedulaEqualRostro ?
                                                (this.state.acuerdoFirmado ?
                                                    <Modal
                                                        isOpen={this.state.modalActualizaciónDocsExitosa}
                                                        cerrarModal={this.cerrarModalActualizaciónDocsExitosa}
                                                        verBoton={true}
                                                        textoBoton="Cerrar"
                                                        srcImagen={cedimg_veri}
                                                        claseHeader={"identificador_exito"}
                                                    >
                                                        <div className="row modal_nuevo">
                                                            <h4 className='text-center'><strong>Se actualizó su solicitud</strong></h4>
                                                            <div className="paso-icono">
                                                                <div className="contenedor-mensaje-modal">
                                                                    <div className="contenedor-interno-mensaje-modal">
                                                                        <div className="mensaje-modal">
                                                                            <p className='text-center'>Deberá estar atento a su correo electrónico alterno para conocer el estado de su solicitud y recibir, de ser necesario, las indicaciones para rectificar sus documentos.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal>
                                                :
                                                    <Modal
                                                        isOpen={this.state.modalActualizaciónDocsExitosa}
                                                        cerrarModal={this.cerrarModalActualizaciónDocsExitosa}
                                                        verBoton={true}
                                                        textoBoton="Ir a firmar el acuerdo"
                                                        srcImagen={cedimg_veri}
                                                        claseHeader={"identificador_exito"}
                                                    >
                                                        <div className="row modal_nuevo">
                                                            <h4 className='text-center'><strong>Cuenta habilitada exitosamente</strong></h4>
                                                            <div className="paso-icono">
                                                                <div className="contenedor-mensaje-modal">
                                                                    <div className="contenedor-interno-mensaje-modal">
                                                                        <div className="mensaje-modal">
                                                                            <p className='mensaje-informativo'>Para completar el proceso de creación, <strong>deberá firmar hasta el {fechaLimite} </strong>el acuerdo de uso de datos personales y medios electrónicos.</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Modal>
                                                )
                                                :
                                                <Modal
                                                    isOpen={this.state.modalActualizaciónDocsExitosa}
                                                    cerrarModal={this.cerrarModalActualizaciónDocsExitosa}
                                                    verBoton={true}
                                                    textoBoton="Cerrar"
                                                    srcImagen={cedimg_veri}
                                                    claseHeader={"identificador_exito"}
                                                >
                                                    <div className="row modal_nuevo">
                                                        <h4 className='text-center'><strong>Se actualizó su solicitud</strong></h4>
                                                        <div className="paso-icono">
                                                            <div className="contenedor-mensaje-modal">
                                                                <div className="contenedor-interno-mensaje-modal">
                                                                    <div className="mensaje-modal">
                                                                        <p className='text-center'>Deberá estar atento a su correo electrónico alterno para conocer el estado de su solicitud y recibir, de ser necesario, las indicaciones para rectificar sus documentos.</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            )
                                    }
                                </div>
                        )
                        :
                        (
                            <div>
                                <Modal isOpen={this.state.modalNoExisteEnBase} cerrarModal={this.cerrarModalnoExisteEnBase} verBoton={false} textoBoton="ACEPTAR" >
                                    <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                                        <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                                    </div>
                                    <p className='text-center nacionalidad-modalnocuenta-texto '>Se ha verificado su solicitud y<b> no tiene un estado de rechazada. </b></p>
                                    <p className="text-center">
                                        <strong>Puede comunicarse con Gerencia de Tecnologías y Servicios de Información</strong></p>
                                    <div className="text-center inactiva-contacto">
                                        <table>
                                            <tr>
                                                <td ><strong>Teléfono: </strong></td>
                                                <td className="nacionalidad-centerTable">(+593) 42269256 </td>
                                            </tr>
                                            <tr>
                                                <td><strong>Atención: </strong></td>
                                                <td className="nacionalidad-centerTable">Lunes a Viernes de 08:00 a 16:00</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Correo: </strong></td>
                                                <td className="nacionalidad-centerTable"><a href="mailto:gerenciatecnologia@espol.edu.ec?" >gerenciatecnologia@espol.edu.ec</a></td>
                                            </tr>
                                        </table>
                                    </div>
                                </Modal>


                            </div>
                        )
                )
            }


        }



    }
}

export default FormUpdateSolicitud
